/** Metadata only, never contact data. Auto school fallback is bounded per
 * authenticated navigation scope, even when several period tables are mounted. */
export function createSchoolCoachReadBudget(limit=25) {
 const scopes=new Map()
 return {
  claim(scope,id){
   if(!scope||!/^\d+$/.test(String(id)))return 'invalid'
   if(!scopes.has(scope)){
    scopes.set(scope,new Set())
    while(scopes.size>8)scopes.delete(scopes.keys().next().value)
   }
   const seen=scopes.get(scope)
   if(seen.has(String(id)))return 'already_read'
   if(seen.size>=limit)return 'budget_reached'
   seen.add(String(id));return 'allowed'
  },
 }
}
export const schoolCoachReadBudget=createSchoolCoachReadBudget()
